import { ProductMapper } from "@omni/mappers/product/product.mapper";
import { ProductTileLayout } from "@omni/ui/brand/product/productTile/productTile.config";
import { useMapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";

import { ProductTile } from "@/components/Product/ProductTile/productTile.container";
import {
    useIsBreakpoint,
    withBreakpoints
} from "@/utils/breakpoints/breakpoints.provider";

import { useProductsContext } from "../../../../context/products.context";

const _Product = () => {
    const { products } = useProductsContext();

    const { index } = useMapped();
    const product = products.at(index);
    const { matches: isSm, ready } = useIsBreakpoint("sm");

    if (!product || !ready) return null;

    const productTileComponents = (
        isSm ? ProductTileLayout.PLP : ProductTileLayout.PLP_HORIZONTAL
    )(true, false, false);

    return (
        <ProductTile
            product={ProductMapper.fromFullToProductTile(product)}
            sku={product.sku}
            allowInstantAddToCart={false}
            className={cn("tw:text-left")}
            productTileConfig={{
                amountOfFeatures: 3,
                components: productTileComponents,
                hoverEffect: true,
                border: true
            }}
        />
    );
};

export const Product = withBreakpoints(_Product);
